import {Directive, Injector, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {FacilityChooserService, OrganizationFacility} from '../../../../@core/facility-chooser.service';
import {FcComponent} from '../../../../@core/fc-component';
import {NoFacilityMessageComponent} from '../no-facility-message/no-facility-message.component';
import {createComponent} from '../../../../utils/component.utils';

export interface CheckFacilityOptions {
    message?: boolean;
    openSelect?: boolean;
    fullHeight?: boolean;
    // Satisfies the gate from the caller's own facility rather than the sidebar
    // picker, for a page rendered outside the normal context -- e.g. Arsana
    // Views in a slide panel, which would otherwise be blanked (and would pop
    // the picker open) whenever the sidebar sat on "All Facilities".
    facility?: number;
}

@Directive({
    selector: '[appCheckFacility]',
})
export class CheckFacilityDirective extends FcComponent implements CheckFacilityOptions {
    @Input('appCheckFacility') options: CheckFacilityOptions;
    message = true;
    openSelect = true;
    fullHeight = true;
    facility: number;

    private _view: 'content' | 'noFac' | null;

    constructor(private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private injector: Injector,
                fc: FacilityChooserService) {
        super(fc);
    }

    ngOnChanges() {
        Object.assign(this, this.options);
    }

    compOnFacChange(orgFac: OrganizationFacility) {
        const facility = this.facility || orgFac.facility;
        if (facility && this._view != 'content') {
            this.viewContainer.clear();
            this.viewContainer.createEmbeddedView(this.templateRef);
            this._view = 'content';
        } else if (!facility && this._view != 'noFac') {
            this.viewContainer.clear();
            if (this.openSelect) setTimeout(() => this.fc.openSelect(), 500);
            if (this.message) {
                const componentRef = createComponent(NoFacilityMessageComponent, this.viewContainer);
                componentRef.instance.fullHeight = this.fullHeight;
                componentRef.changeDetectorRef.detectChanges();
            }
            this._view = 'noFac';
        }
    }
}
